import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Menu, MenuItem, Fade } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import UploadIcon from '@mui/icons-material/Upload';
import EditIcon from '@mui/icons-material/Edit';
import QrCodeIcon from '@mui/icons-material/QrCode';

import CustomTableV2 from "../../common/CustomTableV2";

import { GetCompanies } from '../../redux/company/actions';

import "./style.css";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";

import UploadNewList from "./components/UploadNewList";
import AddOrganization from "./components/AddOrganization";
import EditOrganization from "./components/EditOrganization";
import SignupLink from "./components/SignupLink";

function RegisteredOrganization(props) {
    const [selectedOrg, setSelectedOrg] = useState(null)

    // modal states
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [currentIndex, setCurrentIndex] = useState('');
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // component states
    const [showModal, setShowModal] = useState(false)
    const [sliderContent, setSliderContent] = useState("")

    return (
        <div className="main-container" id="indi-challenge">
            <Fade in={true}>
                <div>
                    <CustomTableV2
                        title="ORGANIZATIONS"
                        description="Control permission of organization."
                        store={props.Company}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Name", value: "name", },
                                { title: "Primary Contact" },
                                { title: "Total Employees" },
                                { title: "Created Password" },
                                { title: "+1 Users" },
                                { title: "Status" },
                                { title: "Permissions" },
                            ],
                            body: (org, i) => {
                                const allUsers = JSON.parse(org?.all_users);
                                let totalUsers = 0, totalActiveUsers = 0, totalPlus1Users = 0;
                                allUsers?.forEach(user => {
                                    if (user?.user_status == 1 && !user?.parent_user) totalUsers++;
                                    if (user?.parent_user) totalPlus1Users++;
                                    if (user?.user_status == 1 && !user?.parent_user && user?.user_password) totalActiveUsers++;
                                });

                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{org.name?.toUpperCase()}</h5></td>
                                        <td><h5>{org?.firstname ? (`${org?.firstname} ${org?.midname} ${org?.lastname}`).toUpperCase() : "-"}</h5></td>
                                        <td><h5>{totalUsers}</h5></td>
                                        <td><h5>{totalActiveUsers}</h5></td>
                                        <td><h5>{totalPlus1Users}</h5></td>
                                        <td><h5>{org?.companyStatus ? "ACTIVE" : "DEACTIVATED"}</h5></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            handleClose();
                                                            setSelectedOrg(org);
                                                            setShowModal(true);
                                                            setSliderContent("EDIT");
                                                        }}><EditIcon sx={{ mr: '10px' }} /> Edit</MenuItem>
                                                        <MenuItem onClick={() => {
                                                            handleClose();
                                                            setSelectedOrg(org);
                                                            setShowModal(true);
                                                            setSliderContent("UPLOAD");
                                                        }}><UploadIcon sx={{ mr: '10px' }} /> Upload</MenuItem>
                                                        <MenuItem onClick={() => {
                                                            handleClose();
                                                            setSelectedOrg(org);
                                                            // setShowLink(!showLink);
                                                            setShowModal(true);
                                                            setSliderContent("LINK");
                                                        }}><QrCodeIcon sx={{ mr: '10px' }} /> Copy Link</MenuItem>
                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}

                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetCompanies(page, count, filter, sort);
                            },
                            add: () => {
                                setShowModal(prev => !prev)
                                setSelectedOrg(null);
                                setSliderContent("ADD");
                            },
                        }}
                    />
                </div>
            </Fade>


            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={""}>

                {
                    (sliderContent == "UPLOAD" || sliderContent == "ADD") &&
                    <>
                        {
                            selectedOrg
                                ? <UploadNewList company={selectedOrg} setShowSlider={(bool) => {
                                    setShowModal(bool);
                                    setSelectedOrg(null);
                                }} />
                                : <AddOrganization setShowSlider={setShowModal} />
                        }
                    </>
                }

                {
                    (sliderContent == "EDIT") &&
                    <>
                        <EditOrganization organization={selectedOrg || ''} />
                    </>
                }


                {
                    (sliderContent == "LINK") &&
                    <>
                        <SignupLink organization={selectedOrg} />
                    </>
                }
            </CustomSliderModalV2>

        </div>
    );
}

const mapStateToProps = (state) => ({
    Company: state.Company,
})

export default connect(mapStateToProps, {
    GetCompanies,
})(RegisteredOrganization);
